import Footer from 'common/components/layout/Footer'

const EmptyState = () => {
  return (
    <div className="flex flex-col justify-center items-center w-full h-full bg-warmGray-50">
      <img
        className="h-52 w-40 mb-12"
        src="/images/empty-state.svg"
        alt="empty state"
      />
      <h2 className="text-xl font-medium mb-4">Welcome to personalization</h2>
      <p className="text-base text-coolGray-400 mb-8">
        No personalization experiments available
      </p>
      <Footer />
    </div>
  )
}

export default EmptyState
